import React, { useMemo } from 'react';
import './index.scss';
import sortdown from '@/pages/intelligence/assets/svg/selectIcon/arrow-bottom.svg';
import sortup from '@/pages/intelligence/assets/svg/selectIcon/arrow-sortup.svg';
import sorted from '@/pages/intelligence/assets/svg/selectIcon/arrow-sorted.svg';
import { SortNameMap, SourceDataMap } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { SortedByTargetProps } from '@/pages/intelligence/pages/_config/topchartsInterface';
import { getLocale, connect } from 'umi';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

const sourceList = ['newzoo', 'npd', 'steamcharts', 'steam', 'appannie', 'sensortower', 'stream', 'databrain', 'hatchet', 'mscience'];
const appannieList = ['D2', 'D3', 'D7', 'D15', 'D31'];
const ImgMap = {
  sortdown,
  sortup,
  desc: sortdown,
  asc: sortup,
  sorted
} as any;

const ArrowdownText = (props: SortedByTargetProps) => {

  const locale = getLocale();
  const { formatMessage } = useIntlExtend();
  const {
    sortedByValue,
    isNew = false,
    nameTextMap,
    auType,
    timeType,
    sortedData,
    order,
    icon,
    text = '',
    sortByKey,
    dataSourcesColumns,
  } = props;

  // console.log('ArrowdownText', props);

  let list = sortedByValue?.order_metric?.split('_')
  let dataSource = ''
  let dataName = sortedByValue?.order_metric
  if (list && list?.length > 1) {
    if (sourceList.includes(list[0])) {
      dataSource = list[0]
      dataName = '';
      for (let i = 1; i < list?.length; i++) {
        const item = list[i];
        dataName = dataName ? `${dataName}_${item}` : item
      }
    } else if (appannieList.includes(list[0])) {
      list?.unshift('appannie')
      dataSource = 'appannie';
      dataName = '';
      for (let i = 1; i < list?.length; i++) {
        const item = list[i] === 'ratio' ? '(%)' : list[i];
        dataName = dataName ? `${dataName}${item}` : item
      }
    }
  } else if (list && list?.length === 1) {
    if (appannieList.includes(list[0])) {
      list?.unshift('appannie')
      dataSource = 'appannie';
      dataName = '';
      for (let i = 1; i < list?.length; i++) {
        const item = list[i];
        dataName = dataName ? `${dataName} ${item}` : item
      }
    }
  }
  let nameMap = SortNameMap;
  if (nameTextMap) {
    nameMap = { ...nameMap, ...nameTextMap }
  }
  if (dataSource === 'mscience' && dataName.includes('revenue')) {
    dataName = `digital_${dataName}`
  }
  if (dataSource === 'npd' && dataName.includes('revenue')) {
    dataName = `physical_${dataName}`
  }
  let DWM = ''
  if (auType && ['DAU', 'MAU', 'WAU'].includes(auType) && ['au_change', 'au', 'au_radio'].includes(dataName)) {
    DWM = auType[0].toUpperCase()
  }
  if (timeType && ['au_change', 'au', 'au_radio'].includes(dataName)) {
    DWM = timeType[0].toUpperCase()
  }

  const sortedDataValue = useMemo(() => {
    if (sortByKey && dataSourcesColumns) {
      return formatMessage({ id: dataSourcesColumns?.find((item: any) => item.value == sortByKey)?.text });
    } else {
      return formatMessage({ id: sortedData })
    }
  }, [sortedData, sortByKey, locale]);

  return (
    (text && text != '') ?
      <span className="dbi-details-text">
        {text}(<img className="dbi-details-text-icon" src={sortdown} />)
      </span>
      : isNew ? <span className="dbi-details-text">
        {formatMessage(
          { id: 'dbi_sorted_by' },
          {
            sortData: (
              <>
                {icon ? ` ${SourceDataMap[icon] || icon}` : ''}
                {sortedDataValue}
              </>
            ),
          },
        )}
        &nbsp;
        (<img className="dbi-details-text-icon" src={ImgMap[order] || sorted} />)
      </span>
        : dataName ?
          <span className="dbi-details-text">
            {formatMessage({ id: 'dbi_sorted_by' }) + ' '}
            {dataSource ? ` ${(SourceDataMap[dataSource] || dataSource)}` : ''}
            {` ${DWM}${nameMap[dataName] || dataName} `}
            &nbsp;
            (<img className="dbi-details-text-icon" src={ImgMap[sortedByValue.order] || sorted} />)
          </span>
          : null
  );
};

export default ArrowdownText;
